module.exports = __webpack_public_path__ + "lato-medium-acbd6ecc97c80340e9bf00ea80063234.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-medium/lato-medium.woff
// module id = 1051
// module chunks = 0